export const scrollToSection = async (hash: string) => {
  // this is to make sure page is loaded
  await new Promise((resolve) => setTimeout(resolve, 100))

  const element = document.getElementById(hash.replace('#', ''))
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}
